import { Controller } from "@hotwired/stimulus"

// On change for checkboxes and selects, sends fetch() to the specified URL with form data.
// A checkbox sends its value when checked and "0" when unchecked, so the server
// receives the state shown on screen. If the server does not save the change
// (error status, or a redirect to login), the checkbox is reverted and the user
// is warned. On success, a JSON body is published as `remote-toggle:guardado`.
export default class extends Controller {
  static values = { url: String, method: { type: String, default: "POST" } }

  change (event) {
    const input = event.target
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new FormData()
    body.append(input.name, this.#valor(input))

    fetch(this.urlValue, {
      method: this.methodValue,
      headers: { "X-CSRF-Token": token },
      body,
      credentials: "same-origin"
    })
      .then(response => {
        if (!response.ok || response.redirected) throw new Error(`HTTP ${response.status}`)

        return this.#esJson(response) ? response.json() : null
      })
      .then(datos => { if (datos) this.dispatch("guardado", { detail: datos }) })
      .catch(() => this.#revertir(input))
  }

  #valor (input) {
    return input.type === "checkbox" && !input.checked ? "0" : input.value
  }

  #esJson (response) {
    return response.headers?.get("content-type")?.includes("json")
  }

  #revertir (input) {
    if (input.type === "checkbox") input.checked = !input.checked
    window.alert("No se ha podido guardar el cambio. Inténtalo de nuevo.")
  }
}
